import { t } from "i18next";
import wearablesIcon from "../../assets/images/wearables.svg";
import { useEffect, useState } from "react";
import { getUserWearables } from "../../services/user";
import { Button } from "react-bootstrap";
import { emptyUserWearables, UserWearables } from "../../interfaces/user";
import { LoadingSpinner } from "../general/loading-spinner";

export default function Wearables() {
    const [showWearables, setShowWearables] = useState(false);
    const [userWearables, setUserWearables] = useState<UserWearables>(emptyUserWearables);
    const [status, setStatus] = useState(2);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getUserWearables()
            .then(response => {
                const newUserWearables: UserWearables = response.data;
                let status = 2;
                /*
                    0 -> no garmin data
                    1 -> do refresh token
                    2 -> do nothing
                */
                if (newUserWearables.garmin_last_refresh.length > 0 && newUserWearables.garmin_expires_in.length) {
                    if (parseInt(newUserWearables.garmin_last_refresh + newUserWearables.garmin_expires_in) < Date.now()) {
                        if (newUserWearables.garmin_last_refresh.length > 0 && newUserWearables.garmin_refresh_token_expires_in.length) {
                            if (parseInt(newUserWearables.garmin_last_refresh + newUserWearables.garmin_expires_in) < Date.now()) {
                                status = 0;
                            } else {
                                status = 1;
                            }
                        }
                    }
                } else {
                    status = 0;
                }

                setStatus(status);

                switch (status) {
                    case 0: // Show message to connect to garmin
                        break;
                    case 1: // do refresh token
                        // refreshWearbleToken();
                        break;
                    case 2: // data is ok
                        setUserWearables(newUserWearables);
                        break;
                }
                
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleWearablesShow =  (event: any) => {
        event.preventDefault();
        setShowWearables(!showWearables);
    }

    const handleWearablesHide =  (event: any) => {
        event.preventDefault();
        setShowWearables(false);
    }

    const handleWearableConnect = () => {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        localStorage.setItem('code_verifier', '6KCasl30RMmVc0BPpv4OpwArGvsa5512kWEpmE3iv4IWw5jQZm');
        localStorage.setItem('code_challenge', 'FzQvV-nCpK37jPQvEvfd9sKz9vy3IdVZ4kN5rs0F90A');
        localStorage.setItem('state', Array(50).join().split(',').map(function() { return chars.charAt(Math.floor(Math.random() * chars.length)); }).join(''));

        const url = 'https://connect.garmin.com/oauth2Confirm' +
            '?client_id=8caeaa1a-e92b-45c4-a12c-076f3cbada47' +
            '&response_type=code' +
            '&redirect_uri=' + window.location.protocol + '//' + window.location.host +
            '&code_challenge=' + localStorage.getItem('code_challenge') +
            '&code_challenge_method=S256' +
            '&state=' + localStorage.getItem('state');
        window.location.href= url;
    }

    return(
        <div className="wearables">
            <div className="action">
                <div className="inner">
                    <img src={ wearablesIcon } alt={ t("wearables") } onClick={ handleWearablesShow }/>
                    <div className="icon-name">{ t("wearables") }</div>
                </div>
            </div>
            { showWearables && 
                <div className="wearables-content">
                    { !loaded && <LoadingSpinner /> }
                    { loaded &&
                        <div className="wearables-content-inner">
                            <a href="#" className="close" onClick={ handleWearablesHide }></a>
                            { userWearables.garmin_access_token !== undefined && userWearables.garmin_access_token.length == 0 &&
                                <div className="wearable-not-connected">
                                    <div className="wearable-icon">
                                        <i className="bi bi-smartwatch"></i>
                                    </div>
                                    <div className="message">
                                        { t("Establish a link between Padeltech and your Garmin Connect account and grant the necessary permissions so we can sync information with your profile.")}
                                    </div>
                                    <Button onClick={ handleWearableConnect }>
                                        { t("Link with Garmin Connect") }
                                    </Button>
                                </div>
                            }
                            { userWearables.garmin_access_token.length > 0 &&
                                <div className="message">
                                    <div className="wearable-icon">
                                        <i className="bi bi-smartwatch"></i>
                                    </div>
                                    { t("Wearable is already connected. No acction needed.") }
                                    <div className="wearable-connection-data">
                                        <div className="user-id">
                                            <div className="label">{ t("User ID") }</div>
                                            <div className="value">{ userWearables.garmin_user_id }</div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    );
}